var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickGreen2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.588,
    height: 15.831,
    viewBox: "0 0 21.588 15.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34967",
    "data-name": "Path 34967",
    d: "M29.11,9.812a2.159,2.159,0,0,1,0,3.053L17.6,24.379a2.159,2.159,0,0,1-3.053,0L8.786,18.622a2.159,2.159,0,1,1,3.053-3.053l4.23,4.23,9.987-9.987A2.159,2.159,0,0,1,29.11,9.812Z",
    transform: "translate(-8.154 -9.179)",
    fill: "#00c245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen2);
export default __webpack_public_path__ + "static/media/tickGreen2.a8449518.svg";
export { ForwardRef as ReactComponent };